export const KEYCLOAK = getEnv(
  "KEYCLOAK",
  "https://keycloak.dev.rede.tst/auth"
);

export const API = getEnv(
  "API",
  "https://tstsaude-api.dev.rede.tst/rest"  
);


function getEnv(envName, defaultValue) {
  if (!window.env) {
    window.env = {};
  }

  if (window.env[envName] == null) {
    window.env[envName] = defaultValue;
  }

  return window.env[envName];
}
